/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ListIdRouteImport } from './routes/$listId'
import { Route as BuyYearlyRouteImport } from './routes/buy-yearly'
import { Route as PreviewRequestRouteImport } from './routes/preview-request'
import { Route as SettingsRouteImport } from './routes/settings'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ListIdRoute = ListIdRouteImport.update({
  id: '/$listId',
  path: '/$listId',
  getParentRoute: () => rootRouteImport,
} as any)
const BuyYearlyRoute = BuyYearlyRouteImport.update({
  id: '/buy-yearly',
  path: '/buy-yearly',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewRequestRoute = PreviewRequestRouteImport.update({
  id: '/preview-request',
  path: '/preview-request',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$listId': typeof ListIdRoute
  '/buy-yearly': typeof BuyYearlyRoute
  '/preview-request': typeof PreviewRequestRoute
  '/settings': typeof SettingsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$listId': typeof ListIdRoute
  '/buy-yearly': typeof BuyYearlyRoute
  '/preview-request': typeof PreviewRequestRoute
  '/settings': typeof SettingsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$listId': typeof ListIdRoute
  '/buy-yearly': typeof BuyYearlyRoute
  '/preview-request': typeof PreviewRequestRoute
  '/settings': typeof SettingsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/$listId' | '/buy-yearly' | '/preview-request' | '/settings'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/$listId' | '/buy-yearly' | '/preview-request' | '/settings'
  id:
    | '__root__'
    | '/'
    | '/$listId'
    | '/buy-yearly'
    | '/preview-request'
    | '/settings'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ListIdRoute: typeof ListIdRoute
  BuyYearlyRoute: typeof BuyYearlyRoute
  PreviewRequestRoute: typeof PreviewRequestRoute
  SettingsRoute: typeof SettingsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$listId': {
      id: '/$listId'
      path: '/$listId'
      fullPath: '/$listId'
      preLoaderRoute: typeof ListIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buy-yearly': {
      id: '/buy-yearly'
      path: '/buy-yearly'
      fullPath: '/buy-yearly'
      preLoaderRoute: typeof BuyYearlyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview-request': {
      id: '/preview-request'
      path: '/preview-request'
      fullPath: '/preview-request'
      preLoaderRoute: typeof PreviewRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ListIdRoute: ListIdRoute,
  BuyYearlyRoute: BuyYearlyRoute,
  PreviewRequestRoute: PreviewRequestRoute,
  SettingsRoute: SettingsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
